const data = [
    {
        'rank': 1,
        'region': 'Greater London',
        'county': 'Greater London',
        'cameras': 5.83,
        'potholes': 8.7,
        'speed': 10,
        'delay': 10,
        'total': 34.53,
        'avg': 8.63
    },
    {
        'rank': 2,
        'region': 'North West',
        'county': 'Greater Manchester',
        'cameras': 6.38,
        'potholes': 8.48,
        'speed': 8.91,
        'delay': 6.92,
        'total': 30.69,
        'avg': 7.67
    },
    {
        'rank': 3,
        'region': 'West Midlands',
        'county': 'West Midlands',
        'cameras': 4.24,
        'potholes': 5.79,
        'speed': 8.12,
        'delay': 6.09,
        'total': 24.25,
        'avg': 6.06
    },
    {
        'rank': 4,
        'region': 'North West',
        'county': 'Lancashire',
        'cameras': 10,
        'potholes': 5.76,
        'speed': 5.47,
        'delay': 1.51,
        'total': 22.74,
        'avg': 5.68
    },
    {
        'rank': 5,
        'region': 'South East',
        'county': 'Surrey',
        'cameras': 2.8,
        'potholes': 8.51,
        'speed': 5.42,
        'delay': 3.3,
        'total': 20.03,
        'avg': 5.01
    },
    {
        'rank': 6,
        'region': 'Yorkshire and the Humber',
        'county': 'West Yorkshire',
        'cameras': 5.02,
        'potholes': 4.12,
        'speed': 6.94,
        'delay': 4.2,
        'total': 20.28,
        'avg': 5.07
    },
    {
        'rank': 7,
        'region': 'East',
        'county': 'Essex',
        'cameras': 7.12,
        'potholes': 6.29,
        'speed': 2.66,
        'delay': 1.79,
        'total': 17.86,
        'avg': 4.47
    },
    {
        'rank': 8,
        'region': 'East',
        'county': 'Bedfordshire',
        'cameras': 3.58,
        'potholes': 7.01,
        'speed': 4.45,
        'delay': 2.84,
        'total': 17.88,
        'avg': 4.47
    },
    {
        'rank': 9,
        'region': 'South East',
        'county': 'Berkshire',
        'cameras': 4.58,
        'potholes': 3.08,
        'speed': 5.84,
        'delay': 4.72,
        'total': 18.22,
        'avg': 4.55
    },
    {
        'rank': 10,
        'region': 'East',
        'county': 'Hertfordshire',
        'cameras': 3.28,
        'potholes': 7.91,
        'speed': 3.25,
        'delay': 2.22,
        'total': 16.67,
        'avg': 4.17
    },
    {
        'rank': 11,
        'region': 'Yorkshire and the Humber',
        'county': 'Kingston Upon Hull',
        'cameras': 0.15,
        'potholes': 0,
        'speed': 9.85,
        'delay': 8.21,
        'total': 18.2,
        'avg': 4.55
    },
    {
        'rank': 12,
        'region': 'South East',
        'county': 'Kent',
        'cameras': 4.43,
        'potholes': 6.48,
        'speed': 3.64,
        'delay': 2.09,
        'total': 16.64,
        'avg': 4.16
    },
    {
        'rank': 13,
        'region': 'South East',
        'county': 'East Sussex',
        'cameras': 1,
        'potholes': 10,
        'speed': 3.69,
        'delay': 1.59,
        'total': 16.28,
        'avg': 4.07
    },
    {
        'rank': 14,
        'region': 'North West',
        'county': 'Merseyside',
        'cameras': 2.07,
        'potholes': 1.77,
        'speed': 7.43,
        'delay': 5.23,
        'total': 16.49,
        'avg': 4.12
    },
    {
        'rank': 15,
        'region': 'Yorkshire and the Humber',
        'county': 'South Yorkshire',
        'cameras': 2.69,
        'potholes': 4.44,
        'speed': 5.61,
        'delay': 3.15,
        'total': 15.89,
        'avg': 3.97
    },
    {
        'rank': 16,
        'region': 'South East',
        'county': 'Hampshire',
        'cameras': 4.54,
        'potholes': 6.4,
        'speed': 2.22,
        'delay': 1.16,
        'total': 14.31,
        'avg': 3.58
    },
    {
        'rank': 17,
        'region': 'North East',
        'county': 'Tyne and Wear',
        'cameras': 2.4,
        'potholes': 1.21,
        'speed': 6.11,
        'delay': 3.46,
        'total': 13.17,
        'avg': 3.29
    },
    {
        'rank': 18,
        'region': 'North West',
        'county': 'Cheshire',
        'cameras': 3.62,
        'potholes': 1.73,
        'speed': 4.12,
        'delay': 2.7,
        'total': 12.16,
        'avg': 3.04
    },
    {
        'rank': 19,
        'region': 'Yorkshire and the Humber',
        'county': 'York',
        'cameras': 0,
        'potholes': 0.2,
        'speed': 7.04,
        'delay': 4.79,
        'total': 12.02,
        'avg': 3.01
    },
    {
        'rank': 20,
        'region': 'East Midlands',
        'county': 'Derbyshire',
        'cameras': 3.58,
        'potholes': 3.06,
        'speed': 3.15,
        'delay': 1.28,
        'total': 11.07,
        'avg': 2.77
    },
    {
        'rank': 21,
        'region': 'South West',
        'county': 'Gloucestershire',
        'cameras': 1.4,
        'potholes': 4.34,
        'speed': 3.5,
        'delay': 1.94,
        'total': 11.18,
        'avg': 2.79
    },
    {
        'rank': 22,
        'region': 'South East',
        'county': 'Isle of Wight',
        'cameras': 2.51,
        'potholes': 0.56,
        'speed': 5.81,
        'delay': 2.51,
        'total': 11.39,
        'avg': 2.85
    },
    {
        'rank': 23,
        'region': 'South East',
        'county': 'Buckinghamshire',
        'cameras': 2.32,
        'potholes': 3.39,
        'speed': 3.15,
        'delay': 1.53,
        'total': 10.39,
        'avg': 2.6
    },
    {
        'rank': 24,
        'region': 'South East',
        'county': 'Oxfordshire',
        'cameras': 3.32,
        'potholes': 3.13,
        'speed': 2.22,
        'delay': 1.5,
        'total': 10.16,
        'avg': 2.54
    },
    {
        'rank': 25,
        'region': 'West Midlands',
        'county': 'Staffordshire',
        'cameras': 2.73,
        'potholes': 2.2,
        'speed': 3.74,
        'delay': 1.6,
        'total': 10.27,
        'avg': 2.57
    },
    {
        'rank': 26,
        'region': 'East Midlands',
        'county': 'Nottinghamshire',
        'cameras': 3.28,
        'potholes': 1.69,
        'speed': 3.4,
        'delay': 1.71,
        'total': 10.08,
        'avg': 2.52
    },
    {
        'rank': 27,
        'region': 'East',
        'county': 'Norfolk',
        'cameras': 3.76,
        'potholes': 2.09,
        'speed': 2.56,
        'delay': 1.32,
        'total': 9.73,
        'avg': 2.43
    },
    {
        'rank': 28,
        'region': 'East Midlands',
        'county': 'Northamptonshire',
        'cameras': 3.58,
        'potholes': 1.81,
        'speed': 2.81,
        'delay': 1.48,
        'total': 9.68,
        'avg': 2.42
    },
    {
        'rank': 29,
        'region': 'South East',
        'county': 'West Sussex',
        'cameras': 1.66,
        'potholes': 3.79,
        'speed': 2.56,
        'delay': 1.44,
        'total': 9.44,
        'avg': 2.36
    },
    {
        'rank': 30,
        'region': 'South West',
        'county': 'Somerset',
        'cameras': 3.28,
        'potholes': 1.27,
        'speed': 3.2,
        'delay': 1.35,
        'total': 9.11,
        'avg': 2.28
    },
    {
        'rank': 31,
        'region': 'East',
        'county': 'Cambridgeshire',
        'cameras': 2.51,
        'potholes': 2.34,
        'speed': 2.31,
        'delay': 1.47,
        'total': 8.63,
        'avg': 2.16
    },
    {
        'rank': 32,
        'region': 'East',
        'county': 'Suffolk',
        'cameras': 1.22,
        'potholes': 2.25,
        'speed': 3.05,
        'delay': 1.38,
        'total': 7.9,
        'avg': 1.97
    },
    {
        'rank': 33,
        'region': 'East Midlands',
        'county': 'Leicestershire',
        'cameras': 2.29,
        'potholes': 0.95,
        'speed': 2.61,
        'delay': 1.71,
        'total': 7.56,
        'avg': 1.89
    },
    {
        'rank': 34,
        'region': 'West Midlands',
        'county': 'Warwickshire',
        'cameras': 1.48,
        'potholes': 0.97,
        'speed': 3.15,
        'delay': 1.6,
        'total': 7.2,
        'avg': 1.8
    },
    {
        'rank': 35,
        'region': 'South West',
        'county': 'Devon',
        'cameras': 2.44,
        'potholes': 1.28,
        'speed': 1.87,
        'delay': 0.81,
        'total': 6.39,
        'avg': 1.6
    },
    {
        'rank': 36,
        'region': 'North West',
        'county': 'Cumbria',
        'cameras': 1.33,
        'potholes': 1.55,
        'speed': 2.41,
        'delay': 0.88,
        'total': 6.17,
        'avg': 1.54
    },
    {
        'rank': 37,
        'region': 'West Midlands',
        'county': 'Worcestershire',
        'cameras': 1.44,
        'potholes': 0.69,
        'speed': 2.36,
        'delay': 1.37,
        'total': 5.86,
        'avg': 1.46
    },
    {
        'rank': 38,
        'region': 'Yorkshire and the Humber',
        'county': 'North Yorkshire',
        'cameras': 1.25,
        'potholes': 2.29,
        'speed': 1.43,
        'delay': 0.64,
        'total': 5.62,
        'avg': 1.4
    },
    {
        'rank': 39,
        'region': 'East Midlands',
        'county': 'Lincolnshire',
        'cameras': 3.36,
        'potholes': 1.44,
        'speed': 0.2,
        'delay': 0.36,
        'total': 5.35,
        'avg': 1.34
    },
    {
        'rank': 40,
        'region': 'South West',
        'county': 'Cornwall',
        'cameras': 1.44,
        'potholes': 1.24,
        'speed': 2.31,
        'delay': 0.78,
        'total': 5.78,
        'avg': 1.45
    },
    {
        'rank': 41,
        'region': 'South West',
        'county': 'Dorset',
        'cameras': 2.36,
        'potholes': 0.98,
        'speed': 0.79,
        'delay': 0.58,
        'total': 4.71,
        'avg': 1.18
    },
    {
        'rank': 42,
        'region': 'South West',
        'county': 'Wiltshire',
        'cameras': 0.48,
        'potholes': 1.23,
        'speed': 2.17,
        'delay': 0.8,
        'total': 4.68,
        'avg': 1.17
    },
    {
        'rank': 43,
        'region': 'West Midlands',
        'county': 'Herefordshire',
        'cameras': 0.11,
        'potholes': 1.7,
        'speed': 1.72,
        'delay': 0.69,
        'total': 4.22,
        'avg': 1.05
    },
    {
        'rank': 44,
        'region': 'West Midlands',
        'county': 'Shropshire',
        'cameras': 0.96,
        'potholes': 1.11,
        'speed': 0.79,
        'delay': 0.61,
        'total': 3.46,
        'avg': 0.86
    },
    {
        'rank': 45,
        'region': 'North East',
        'county': 'Northumberland',
        'cameras': 1.37,
        'potholes': 1.03,
        'speed': 0.25,
        'delay': 0.24,
        'total': 2.88,
        'avg': 0.72
    },
    {
        'rank': 46,
        'region': 'North East',
        'county': 'County Durham',
        'cameras': 0.41,
        'potholes': 0.41,
        'speed': 1.23,
        'delay': 0.65,
        'total': 2.7,
        'avg': 0.67
    },
    {
        'rank': 47,
        'region': 'Yorkshire and the Humber',
        'county': 'East Riding of Yorkshire',
        'cameras': 0.7,
        'potholes': 0.55,
        'speed': 0,
        'delay': 0,
        'total': 1.25,
        'avg': 0.31
    }
];